import { User, PzPublisher } from 'models';
import { UserAnalyticsMicroMessageContent } from 'models/analytics';
import { approvalStatusMapping } from './approval-status-mapping';

function getUserAnalyticsMicroMessage(user: User, pzPublisher?: PzPublisher) {
  const messageContent: UserAnalyticsMicroMessageContent = {
    hubUserId: `${user?.seqId ?? 'ANONYMOUS'}`,
    userSegment: `${user?.industry ?? 'PREVIEW'}`,
    hubUserStatus: `${user?.isTestUser ? 'testuser' : 'realuser'}`,
    hubOnboardingStatus: `${
      pzPublisher?.network_status ? approvalStatusMapping[pzPublisher?.network_status] : 'UNKNOWN'
    }`,
  };

  return {
    schemaName: 'affiliateHubUser',
    messageContent,
  };
}

export { getUserAnalyticsMicroMessage };
